__turbopack_context__.v({
  "wrapper": "tabs-module__psrLGW__wrapper",
});
